import { SignedOut, SignedIn } from '@clerk/clerk-react';

export const ClerkSignedOut = SignedOut as React.FC<{ children: React.ReactNode }>;
export const ClerkSignedIn = SignedIn as React.FC<{ children: React.ReactNode }>;
